'use client';

import { c as _c } from "react/compiler-runtime";
import image from '@images/renders/architecture_images/arch_01.webp';
import kamen from '@images/renders/architecture_images/kamen.svg';
import cn from 'classnames';
import NextImage from 'next/image';
import ParallaxMedia from '../../parallax-media/ParallaxMedia';
import style from './Architecture.module.scss';
import ArchitectureBackgroundAnimation from './components/ArchitectureBackgroundAnimation';
const Architecture = () => {
  const $ = _c(19);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={style.firstBox}><div className={style.header}><p>Архитектура</p><p>чистых форм</p></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ArchitectureBackgroundAnimation />;
    t2 = <div className={cn(style.descriptionBox, style.descriptionBox__leftBottom)}><div className={cn(style.gradient, style.gradient__leftBottom)} /></div>;
    t3 = cn(style.descriptionBox, style.descriptionBox__rightMiddle);
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <br />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className={t3}><div className={style.descriptionBox__text}>Угловые панорамные окна позволяют насладиться зелёной перспективой {t4} на лесные массивы парка<p><br /></p></div><div className={cn(style.gradient, style.gradient__rightMiddle)} /></div>;
    t6 = cn(style.descriptionBox, style.descriptionBox__leftTop);
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className={style.imageContainerKamen}><NextImage className={style.kamen} src={kamen} alt="icon" /></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <br />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <br />;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div data-scroll={true} className={style.architecture}>{t0}<div className={style.firstScreenContainer}>{t1}{t2}{t5}<div className={t6}>{t7}<div><p className={style.descriptionBox__text}>Авторы уникального архитектурного {t8}облика — бюро с тридцатилетним {t9}портфолио и коллекцией престижных <br />наград — визионеры Kamen Architects.</p></div><div className={cn(style.gradient, style.gradient__leftTop)} /></div></div></div>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <ParallaxMedia className={style.img} src={image} dataScroll={true} dataScrollSpeed="1" dataScrollTarget="#first" imagePlug={image} />;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <p className={style.text}>Если заварить кофе и выйти на балкон — можно ощутить свежесть местного утра во всей его красоте. Наблюдайте за сезонными метаморфозами, богатым созвучием цветов и оттенков природы.</p>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <span className={style.firstLine}>В Моментс утренний кофе</span>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  let t15;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <br />;
    t15 = <span className={style.secondLine}>с созерцанием панорамы</span>;
    $[14] = t14;
    $[15] = t15;
  } else {
    t14 = $[14];
    t15 = $[15];
  }
  let t16;
  let t17;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <br />;
    t17 = <span className={style.thirdLine}>обещает стать неотъемлемой частью </span>;
    $[16] = t16;
    $[17] = t17;
  } else {
    t16 = $[16];
    t17 = $[17];
  }
  let t18;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <>{t10}<div data-scroll={true} id="first" className={style.architectureBottom}>{t11}<div data-scroll={true} data-scroll-speed="1" data-scroll-target="#first" className={style.textBox}>{t12}<p className={style.title}>{t13} {t14}{t15} {t16}{t17} <br /><span className={style.fourthLine}>вашей жизни. </span></p></div></div></>;
    $[18] = t18;
  } else {
    t18 = $[18];
  }
  return t18;
};
export default Architecture;